import z from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
  nullSafeString,
} from '../shared/schema'

// `user_profile/{uid}/catalogs/{catalogId}` — a catalog access grant. Never had
// a zod schema (docs were read raw); the effective shape comes from the writers
// and `testing/factories.ts`. Added so the catalog backfill parses grants the
// same schema-first way every other collection does.
export const schema = z.object({
  catalogId: nullSafeString(''),
  userId: nullSafeString(''),
  createdAt: nullSafeOptionalFirestoreTimestamp(),
  organizationId: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    catalogId: '',
    userId: '',
  })
)

export interface FirestoreUserProfileCatalog extends z.infer<typeof schema> {}
